import { NotificationsActive, NotificationsNone } from '@mui/icons-material';
import { Badge, Box, IconButton, Popover } from '@mui/material';
import { QuoteCard } from 'quotes/quote-card';
import { useEffect, useState } from 'react';
import { useQueryReminderQuotes } from 'shared/queries/get-reminder-quotes';
import { UserInfo } from 'shared/types';

interface QuoteReminderNotificationsProps {
  brand: string;
  user: UserInfo | null;
}

export function QuoteReminderNotifications({ brand, user }: QuoteReminderNotificationsProps) {
  const { quotes } = useQueryReminderQuotes({
    brand,
    salesRep: user?.displayName,
  });

  const [hasNotifications, toggleHasNotifications] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'notifications-popover' : undefined;

  useEffect(() => {
    if (quotes?.totalCount && quotes?.totalCount > 0) {
      toggleHasNotifications(true);
    } else {
      toggleHasNotifications(false);
    }
  }, [quotes, toggleHasNotifications]);

  return (
    <>
      {hasNotifications ? (
        <IconButton aria-label='notifications-popover' onClick={handleClick}>
          <Badge badgeContent={quotes?.totalCount} color='secondary'>
            <NotificationsActive sx={{ color: 'white' }} />
          </Badge>
        </IconButton>
      ) : (
        <NotificationsNone sx={{ color: 'white' }} />
      )}
      <Popover
        id={id}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ maxWidth: '35vw', maxHeight: '40vh', overflowY: 'scroll' }}>
          {quotes?.data.map((quote, i) => (
            <Box key={i} style={{ padding: '10px' }}>
              <QuoteCard quote={quote} user={user} />
            </Box>
          ))}
        </div>
      </Popover>
    </>
  );
}
